// @flow
import React from 'react';
import type { Node } from 'react';
import Box from '@material-ui/core/Box';
import type { Status } from '../../../types';
import { DEFAULT_STATUS_TIMEOUT } from '../../../constants/configConstants';
import Timer from './Timer';
import StatusBarInput from './StatusBarInput';

type Props = $ReadOnly<{
    label: Node,
    id: string,
    inputs: $ReadOnlyArray<{|id: string, label: string|}>,
    status: Status,
    maxLength: ?number,

    onChange: (key: string, value: string) => void
}>;
function StatusBarItem({ label, id, inputs, status, maxLength, onChange }: Props) {
    const { value, updatedAt, timeout } = status[id] || {};

    const handleChange = (subId) => (inputValue) => {
        let newValue;
        if(inputs.length > 1) {
            newValue = {
                ...value,
                [subId]: inputValue
            };
        }
        else {
            newValue = inputValue;
        }

        onChange(id, newValue);
    };

    return (
        <Box display="flex" alignItems="center" px={2}>

            <Timer
                timestamp={updatedAt}
                duration={typeof timeout !== 'undefined' ? timeout : DEFAULT_STATUS_TIMEOUT}
            />

            {label}

            {inputs.map((input) => (
                <StatusBarInput
                    id={inputs.length === 1 ? id : `${id}:${input.id}`}
                    key={input.id}
                    label={input.label}
                    value={inputs.length > 1 ? value && value[input.id] : value}
                    maxLength={maxLength}
                    onChange={handleChange(input.id)}
                />
            ))}
        </Box>
    )
}

export default StatusBarItem;